import axios, { AxiosError } from 'axios';
import { getCurrentOrganization } from '@/lib/organizationBridge';

export const haciendaClient = axios.create({
  baseURL: import.meta.env.VITE_HACIENDA_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

haciendaClient.interceptors.request.use(
  (config) => {
    const currentOrganization = getCurrentOrganization();
    
    if (currentOrganization?.haciendaApiKey) {
      config.headers.Authorization = `Bearer ${currentOrganization.haciendaApiKey}`;
    } else {
      console.warn('Hacienda API Key not found in organization settings');
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

haciendaClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response) {
      console.error('Hacienda API Error:', error.response.status, error.response.data);
    } else if (error.request) {
      console.warn('Hacienda API No Response:', error.request);
    } else {
      console.error('Hacienda API Error:', error.message);
    }
    return Promise.reject(error);
  }
);

